import produce from "immer";
import { InboundReducerFunction } from "./InboundReducerFunction";

export const updatePackagesForShipmentReducer: InboundReducerFunction = (state, { shipmentId, packages }) =>
  produce(state, (draft) => {
    draft.packages[shipmentId] = packages;
  });
